import React from 'react';
import { Box, Flex, Image, SimpleGrid, Text, Button, Icon, Heading, useColorMode } from '@chakra-ui/react';
// import { useRouter } from 'next/router';
import PowerBy from 'components/PowerBy';
import { Container } from 'components/Container';
import { FiInfo } from 'react-icons/fi';
import Link from 'next/link';
import ModeSwitcher from 'components/ModeSwitcher';
import { bgColor } from 'config/data';

const BoxTier = ({ children }) => {
  const { colorMode } = useColorMode();
  return (
    <Box
      bg={bgColor[colorMode]}
      borderWidth={1}
      borderColor={colorMode === 'dark' ? '#333' : null}
      boxShadow="0 0 13px 11px rgba(0, 0, 0, 0.05)"
      p="10px"
      w={{ base: '100%', md: '100%', lg: '400px' }}
      borderRadius={16}
    >
      {children}
    </Box>
  );
};

const StxLdn = () => {
  const { colorMode } = useColorMode();
  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      alignItems="center"
      id="content"
      pb="30px"
      px={{ base: '15px', md: '15px', lg: 0 }}
    >
      <Container>
        <Flex
          id="header"
          borderBottomWidth={1}
          borderColor={colorMode === 'dark' ? '#333' : null}
          py="20px"
          mb="30px"
          justifyContent="space-between"
        >
          {colorMode === 'dark' ? (
            <Image src="/images/STX-LDN-logo.svg" alt="" />
          ) : (
            <Image src="/images/STX-LDN-logo-dark.svg" alt="" />
          )}

          <ModeSwitcher />
        </Flex>
        <Flex justifyContent="center" mb={{ base: '30px', md: '60px' }} flexDirection="column" alignItems="center">
          <Image w="23px" src="/images/icon-thunder.svg" alt="" mb="25px" />
          <Heading
            fontWeight="700"
            fontSize={{ base: '38px', md: '48px' }}
            textTransform="uppercase"
            textAlign="center"
          >
            STX:LDN Member NFT Drop!
          </Heading>
        </Flex>
        <SimpleGrid columns={[1, 2, 2, 2, 3]} spacing="30px" mb="30px">
          <BoxTier>
            <Image src="/images/STX_T1_preview.gif" alt="" borderRadius={8} />
            <Box
              p="15px 10px 0px"
              id="content"
              h={{ base: '611px', md: '660px', lg: '560px' }}
              display="flex"
              flexDirection="column"
            >
              <Flex flexDirection="column" id="box_top" flexGrow={1}>
                <Flex justifyContent="space-between" id="box_info" mb="25px">
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" mb="10px">
                      TIER 1
                    </Text>
                    <Button
                      color="#CDA349"
                      bg={colorMode === 'dark' ? '#252433' : '#FFF3D9'}
                      h="50px"
                      fontSize="24px"
                      letterSpacing="5.28px"
                      fontWeight="black"
                      variant="black"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#3e3d4a' : '#F3EFE7'}
                      _hover={{ background: '#FFF3D9' }}
                    >
                      MEMBER
                    </Button>
                  </Box>
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" textAlign="right">
                      PRICE
                    </Text>
                    <Text fontSize="32px" fontWeight="bold" color="#CDA349">
                      FREE
                    </Text>
                  </Box>
                </Flex>
                <Box id="box_content" mb="20px">
                  <Flex mb="16px">
                    <Image src="/images/cap-01.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text>104 FREE STX:LDN Member digital design NFTs</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-01.svg" alt="" alignSelf="center" mr="15px" />
                    <Text>Event Q Jump</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-01.svg" alt="" alignSelf="baseline" pt="6px" mr="15px" />
                    <Text lineHeight="1.43">
                      Access to exclusive promotions/discounts and beta testing of Stacks based partner applications
                    </Text>
                  </Flex>
                </Box>
              </Flex>
              <Flex id="box_footer" borderTopWidth={1} paddingTop="20px" flexDirection="column" alignSelf="flex-end">
                <Flex>
                  <Icon as={FiInfo} mr="10px" />
                  <Text color="#4f4f4f" fontSize="12px" mb="13px" fontWeight="500">
                    104 STX:LDN x NFTCC “Get ₿” NFT Designs Exclusive artwork designed for STX:LDN
                  </Text>
                </Flex>
                <a
                  href={
                    'https://multipass.heylayer.com/?badge_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2UiOiJjbGFpbV9iYWRnZSIsImJhZGdlX2lkIjo1LCJleHAiOjE2ODg2ODA4OTR9.rs-RL2sugM2UmMo3t2ZZVc1bRUvwqOVrrMQg7v2sK7M'
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    w="100%"
                    variant="black"
                    bg="#cda349"
                    h="52px"
                    borderRadius="12px"
                    letterSpacing="2.4px"
                    fontSize="16px"
                    fontWeight={600}
                  >
                    MINT FOR FREE
                  </Button>
                </a>
              </Flex>
            </Box>
          </BoxTier>
          <BoxTier>
            <Image src="/images/STX_T2_preview.gif" alt="" borderRadius={8} />
            <Box
              p="15px 10px 0px"
              id="content"
              h={{ base: '611px', md: '660px', lg: '560px' }}
              display="flex"
              flexDirection="column"
            >
              <Flex flexDirection="column" id="box_top" flexGrow={1}>
                <Flex justifyContent="space-between" id="box_info" mb="25px">
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" mb="10px">
                      TIER 2
                    </Text>
                    <Button
                      color="#5546fe"
                      bg={colorMode === 'dark' ? '#252433' : '#eeecff'}
                      h="50px"
                      fontSize="24px"
                      letterSpacing="5.28px"
                      fontWeight="black"
                      variant="black"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#3e3d4a' : '#dedbfd'}
                      _hover={{ background: '#eeecff' }}
                    >
                      VIP
                    </Button>
                  </Box>
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" textAlign="right">
                      PRICE
                    </Text>
                    <Text fontSize="32px" fontWeight="bold" color="#5546fe">
                      125
                    </Text>
                  </Box>
                </Flex>
                <Box id="box_content" mb="20px">
                  <Flex mb="16px">
                    <Image src="/images/cap-02.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text>104 STX:LDN VIP digital design NFTs</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-02.svg" alt="" alignSelf="center" mr="15px" />
                    <Text>Tier 1 benefits</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-02.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">Community Rewards</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-02.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">VIP area access at STX:LDN events</Text>
                  </Flex>
                </Box>
              </Flex>
              <Flex id="box_footer" borderTopWidth={1} paddingTop="20px" flexDirection="column" alignSelf="flex-end">
                <Flex>
                  <Icon as={FiInfo} mr="10px" />
                  <Text color="#4f4f4f" fontSize="12px" mb="13px" fontWeight="500">
                    104 STX:LDN x NFTCC “Get ₿” NFT Designs Exclusive artwork designed for STX:LDN
                  </Text>
                </Flex>
                <Link href="/mintpool/2">
                  <a>
                    <Button
                      w="100%"
                      variant="black"
                      bg="#5546fe"
                      h="52px"
                      borderRadius="12px"
                      letterSpacing="2.4px"
                      fontSize="16px"
                      fontWeight={600}
                    >
                      MINT FOR 125 STX
                    </Button>
                  </a>
                </Link>
              </Flex>
            </Box>
          </BoxTier>
          <BoxTier>
            <Image src="/images/STX_T3_preview.gif" alt="" borderRadius={8} />
            <Box
              p="15px 10px 0px"
              id="content"
              h={{ base: '611px', md: '660px', lg: '560px' }}
              display="flex"
              flexDirection="column"
            >
              <Flex flexDirection="column" id="box_top" flexGrow={1}>
                <Flex justifyContent="space-between" id="box_info" mb="25px">
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" mb="10px">
                      TIER 3
                    </Text>
                    <Button
                      color="#f7931b"
                      bg={colorMode === 'dark' ? '#252433' : '#fff8ec'}
                      h="50px"
                      fontSize="24px"
                      letterSpacing="5.28px"
                      fontWeight="black"
                      variant="black"
                      borderWidth={1}
                      borderColor={colorMode === 'dark' ? '#3e3d4a' : '#fdebdb'}
                      _hover={{ background: '#fff8ec' }}
                    >
                      VIP STACKER
                    </Button>
                  </Box>
                  <Box>
                    <Text letterSpacing="2.64px" fontSize="12px" fontWeight="600" textAlign="right">
                      PRICE
                    </Text>
                    <Text fontSize="32px" fontWeight="bold" color="#f7931b">
                      200
                    </Text>
                  </Box>
                </Flex>
                <Box id="box_content" mb="20px">
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text>104 STX:LDN VIP Stacker digital design NFTs</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text>Tier 1+2 benefits</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Box>
                      <Text lineHeight="1.43">Access Community Stacking Pool </Text>
                      <Text lineHeight="1.43" color="#4f4f4f">
                        (Coming Soon)
                      </Text>
                    </Box>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">Governance Voting (DAO coming Q4 2022)</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">First drink FREE at any STX:LDN event</Text>
                  </Flex>
                  <Flex mb="16px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">
                      First to whitelist (Early whitelisting access to partner product/NFT launches)
                    </Text>
                  </Flex>
                  <Flex mb="0px">
                    <Image src="/images/cap-03.svg" alt="" alignSelf="baseline" mr="15px" />
                    <Text lineHeight="1.43">Standard Physical Genesis Prototype Cap</Text>
                  </Flex>
                </Box>
              </Flex>
              <Flex id="box_footer" borderTopWidth={1} paddingTop="15px" flexDirection="column" alignSelf="flex-end">
                <Flex>
                  <Icon as={FiInfo} mr="10px" />
                  <Text color="#4f4f4f" fontSize="12px" mb="13px" fontWeight="500">
                    104 STX:LDN x NFTCC “Get ₿” NFT Designs Exclusive artwork designed for STX:LDN
                  </Text>
                </Flex>
                <Link href="/mintpool/3">
                  <a>
                    <Button
                      w="100%"
                      variant="black"
                      bg="#f7931b"
                      h="52px"
                      borderRadius="12px"
                      letterSpacing="2.4px"
                      fontSize="16px"
                      fontWeight={600}
                    >
                      MINT FOR 200 STX
                    </Button>
                  </a>
                </Link>
              </Flex>
            </Box>
          </BoxTier>
        </SimpleGrid>
        <PowerBy />
      </Container>
    </Flex>
  );
};

export default StxLdn;
